import { NavLink } from "react-router-dom"
import styles from "./sidebar.module.scss"
import { useContext, useEffect, useState } from "react"
import { SidebarContext } from "./SidebarContext"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons"
import { StudentNotificationSubscribeEvent } from "shared/types/notificationTypes"
import { toast } from "react-toastify"
import { AuthContext } from "AuthContext"

export interface SidebarLink {
    title: string
    path: string
    icon?: IconProp
}

interface Props {
    links: Array<SidebarLink | "separator">
}

export default function SidebarLinks({ links }: Props) {
    const { collapsed, toggleCollapse } = useContext(SidebarContext) // collapse sidebar when a sidebar link is clicked on Only If it's mobile screen
    const { isStudent } = useContext(AuthContext)
    const [notificationReceived, setNotificationReceived] = useState<boolean>(false)

    function onClickNavLink(link: SidebarLink) {
        if (!collapsed && window.innerWidth <= 800) {
            toggleCollapse()
        }
        if (link.title === "Notifications") {
            setNotificationReceived(false)
        }
    }

    useEffect(() => {
        if (!isStudent) return

        const eventSource = new EventSource("/api/student/subscribe-notifications")

        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data) as StudentNotificationSubscribeEvent
            if (data.type === "unread-notifications" || data.type === "new-notification") {
                setNotificationReceived(true)
            }
        }

        eventSource.onerror = () => toast.error("There was an error subscribing to notifications.")
        return () => eventSource.close()
    }, [isStudent])

    return (
        <ul className={styles.sidebarLinks}>
            {links.map((link, index) => {
                if (link === "separator") {
                    return <hr key={`separator-${index}`} />
                } else {
                    const isNotificationLink = link.title === "Notifications"
                    return <NavLink to={link.path} key={link.title + link.path} onClick={() => onClickNavLink(link)}>
                        {
                            ({ isActive }) =>
                                <li className={`${isActive ? styles.active : ""} ${collapsed ? styles.collapsedLink : ""} ${isNotificationLink && !notificationReceived && "text-secondary"}`}>
                                    {link.icon && <FontAwesomeIcon icon={link.icon} className={collapsed ? "" : "me-2"} />}
                                    {collapsed ? "" : link.title}
                                    {isNotificationLink && notificationReceived && <FontAwesomeIcon icon={faCircleExclamation} className="text-primary ms-1 position-absolute" size="lg" />}
                                </li>
                        }
                    </NavLink>
                }
            })}
        </ul>
    )
}
